<template>
  <div class="recognition-container main-view">
		<!-- HEADER STARTS HERE -->
		<div class="bg-container recognition-hero" :style="{'background-image': 'url(' + require(`../assets/img/bgs/sub-page-hero-bg.svg`) + ')'}">
			<div class="template-inner flex-row">
				<div class="one-half flex-row justify-center">
					<h1 class="hero-header">Evergrow inspires<br> employees to <br> do great work <br> that creates<br> great change</h1>
				</div>
				<div class="recognition-header-imgs one-half">
					<img class="" src="@/assets/img/features/recognition-header-bubble.svg" alt="">
					<div class="header-bubbles">
						<img src="@/assets/img/features/recognition-header-bubble-1.png" alt="" class="header-bubble one">
						<img src="@/assets/img/features/recognition-header-bubble-2.png" alt="" class="header-bubble two">
						<img src="@/assets/img/features/recognition-header-bubble-3.png" alt="" class="header-bubble three">
					</div>
				</div>
			</div>
			<bg-wave-element></bg-wave-element>
		</div>
		<!-- HEADER ENDS HERE -->
		<!-- MAIN CONTENT STARTS HERE -->
		<div class="template-inner">
			<h2>Here are some of the many ways a member can build a thriving Evergrow forest</h2>
			<p>Evergrow ignites the power of one-click performance recognition across your organization. Members can instantly recognize a colleague’s great work, birthdays or tenure, with public awards, badges and Evergrow points. And by directly connecting member activity to climate action, we’re making motivation meaningful.</p>
			<!-- RECOGNITION STARTS HERE -->
			<section class="recognition-inner">
				<div class="flex-row main-row">
					<div class="recognition-content flex-row one-half">
						<div class="recognition-icon">
							<img src="@/assets/img/icons/recognition/trophy.svg" alt="Icon of trophy">
						</div>
						<div class="recognition-content-inner">
							<h3>Colleague Awards</h3>
							<p>Recognize a colleague’s great work by awarding them Evergrow points, and they’ll earn a tree.</p>
						</div>
					</div>
					<div class="recognition-content flex-row one-half">
						<div class="recognition-icon">
							<img src="@/assets/img/icons/recognition/cart.svg" alt="Icon of trophy">
						</div>
						<div class="recognition-content-inner">
							<h3>Redeeming Rewards</h3>
							<p>Receive a tree every time you redeem Evergrow points for a reward from our AI-curated gallery of the world’s coolest brands.</p>
						</div>
					</div>
				</div>

				<div class="flex-row main-row">
					<div class="recognition-content flex-row one-half">
						<div class="recognition-icon">
							<img src="@/assets/img/icons/recognition/wacth.svg" alt="Icon of trophy">
						</div>
						<div class="recognition-content-inner">
							<h3>Wellness Challenges</h3>
							<p>Stay healthy, earn Evergrow points and trees when you reach monthly activity targets or participate in team or company wellness challenges.</p>
						</div>
					</div>
					<div class="recognition-content flex-row one-half">
						<div class="recognition-icon">
							<img src="@/assets/img/icons/recognition/survey.svg" alt="Icon of trophy">
						</div>
						<div class="recognition-content-inner">
							<h3>Surveys</h3>
							<p>Provide personal feedback and helpful opinions on surveys and receive Evergrow points and trees.</p>
						</div>
					</div>
				</div>

				<div class="flex-row main-row">
					<div class="recognition-content flex-row one-half">
						<div class="recognition-icon">
							<img src="@/assets/img/icons/recognition/check.svg" alt="Icon of trophy">
						</div>
						<div class="recognition-content-inner">
							<h3>Badges</h3>
							<p>Members can earn points and special badges for going above and beyond with amazing performances, participation and engagement.</p>
						</div>
					</div>
					<div class="recognition-content flex-row one-half">
						<div class="recognition-icon">
							<img src="@/assets/img/icons/recognition/cake.svg" alt="Icon of trophy">
						</div>
						<div class="recognition-content-inner">
							<h3>Birthdays</h3>
							<p>Celebrate every year with special Evergrow birthday awards.</p>
						</div>
					</div>
				</div>

				<div class="flex-row main-row">
					<div class="recognition-content flex-row one-half">
						<div class="recognition-icon">
							<img src="@/assets/img/icons/recognition/calendar.svg" alt="Icon of trophy">
						</div>
						<div class="recognition-content-inner">
							<h3>Anniversaries</h3>
							<p>Mark your employee’s loyalty and commitment on their hiring anniversary with a unique annual Evergrow award.</p>
						</div>
					</div>
				</div>

					<!-- <div class="recognition-content flex-row one-half ">
						<div class="recognition-icon flex-row">
							<img src="@/assets/img/icons/recognition/cart.svg" alt="Icon of trophy">
						</div>
					<div class="recognition-content-inner">
						<h3>Redeeming Rewards</h3>
						<p>Receive a tree every time you redeem Evergrow points for a reward from our AI-curated gallery of the world’s coolest brands.</p>
					</div>
				</div>
				</div>
				<div class="flex-row main-row">
					<div class="recognition-content flex-row one-half">
						<div class="recognition-icon flex-row">
							<img src="@/assets/img/icons/recognition/wacth.svg" alt="Icon of trophy">
						</div>
						<div class="recognition-content-inner">
							<h3>Wellness Challenges</h3>
							<p>Stay healthy, earn Evergrow points and trees when you reach monthly activity targets or participate in team or company wellness challenges.</p>
						</div>
					</div>
						<div class="recognition-content flex-row one-half">
						<div class="recognition-icon flex-row">
							<img src="@/assets/img/icons/recognition/survey.svg" alt="Icon of trophy">
						</div>
						<div class="recognition-content-inner">
							<h3>Surveys</h3>
							<p>Provide personal feedback and helpful opinions on surveys and receive Evergrow points and trees.</p>
						</div>
					</div>
				</div>
				<div class="flex-row main-row">
					<div class="recognition-content flex-row one-half">
					<div class="recognition-icon flex-row">
						<img src="@/assets/img/icons/recognition/check.svg" alt="Icon of trophy">
					</div>
					<div class="recognition-content-inner">
						<h3>Badges</h3>
						<p>Members can earn points and special badges for going above and beyond with amazing performances, participation and engagement.</p>
					</div>
				</div>
					<div class="recognition-content flex-row one-half">
						<div class="recognition-icon flex-row">
							<img src="@/assets/img/icons/recognition/cake.svg" alt="Icon of trophy">
						</div>
					<div class="recognition-content-inner">
						<h3>Birthdays</h3>
						<p>Celebrate every year with special Evergrow birthday awards.</p>
					</div>
				</div>
				</div>
				<div class="flex-row main-row">
						<div class="recognition-content flex-row one-half">
						<div class="recognition-icon flex-row">
							<img src="@/assets/img/icons/recognition/calendar.svg" alt="">
						</div>
					<div class="recognition-content-inner">
						<h3>Anniversaries</h3>
						<p>Mark your employee’s loyalty and commitment on their hiring anniversary with a unique annual Evergrow award.</p>
					</div>
				</div>
				</div> -->
			</section>
			<!-- RECOGNITION ENDS HERE -->
		</div>
		<!-- MAIN CONTENT ENDS HERE -->
		<!-- REWARDS POINTS STARTS HERE -->
		<section class="rewards-info-container recognition">
			<div class="stroke"></div>
			<div class='rewards-info-inner align-center'>
				<img class="" src="@/assets/img/icons/recognition/money.svg" alt="">
				<p>Redeem points from the largest collection of the world’s most loved{{'\xa0'}}rewards.</p>
				<button class="rewards-button" @click="$router.push('/features/rewards')">Learn{{'\xa0'}}more</button>
			</div>
			<div class="stroke"></div>
		</section>
		<!-- REWARDS POINTS ENDS HERE-->
		<!-- //DEMO SECTION -->
		<Demo></Demo>
  </div>
</template>

<script>
import Demo from "../components/Demo";
	export default {
		name: 'Features-Recognition',
		components : {
			Demo
		}
	}
</script>

<style lang="stylus" scoped>

	// ----- HEADER -----
	.bg-container.recognition-hero 
		background center center / cover no-repeat #fff
		display flex
		flex-direction column
		justify-content center
		
		.template-inner
			padding-top 170px

	.recognition-header-imgs
		position relative
		top 72px
		display flex
		justify-content center
		
		img
			width 80%

	.header-bubbles
		position absolute
		width 100%
		height 100%
		top 40px
		
		img
			position absolute
			box-shadow 0px 20px 40px #00000033
			border-radius 100%
		
			&.header-bubble.one
				width 120px
				top 5%
				left 3%
			&.header-bubble.two
				width 200px
				top -19%
				right -3%
			&.header-bubble.three
				width 150px
				bottom 8%
				right 4%
		
		// ----- BADGES ---- 

	.recognition-container h2 + p
		text-align center
		// width 60%
		margin 0 auto

	.recognition-container h2
		font-size 50px
		text-align center
		// width 75%
		margin 80px auto 40px

	.recognition-container h3
		font-family 'Poppins', sans-serif
		font-weight  600
		margin-bottom 10px
		font-size 24px
		line-height 32px

	.recognition-content
		align-items center
	
	.recognition-icon 
		background #fff
		box-shadow 0px 20px 40px #00000033
		padding 30px
		box-sizing	border-box
		width 170px
		height 170px
		display flex
		justify-content center
		align-items center
		// margin-right 30px
		border-radius 100%
		
		img
			height 80px

	.recognition-inner
		margin 0 auto
		
		.main-row
			padding-top 80px
			
		.recognition-content-inner
			width calc(100% - 170px)
			padding-left 30px
			box-sizing border-box

	.rewards-info-container
		margin-top 180px

	@media (max-width: 1000px)
		.bg-container.recognition-hero svg
			display none 
			
		.bg-container.recognition-hero .template-inner
			flex-direction column 
			
			.one-half
				width 100% !important
				
				.hero-header	
					font-size 52px
					text-align center
		
		.recognition-header-imgs
			padding 80px 0
			top 0	
			
			img
				width 310px
				height 310px	

		.header-bubbles img.header-bubble.one
			width 56px
			height 56px
			top 20%
			left 3%

		.header-bubbles img.header-bubble.two
			width 96px
			height 96px
			top 1%
			right 7%
			
		.header-bubbles img.header-bubble.three
			width 65px
			height 65px
			bottom 26%
			right 10%
			
		.recognition-inner 
			margin-top 60px

			.flex-row.main-row
				flex-direction column !important
				padding-top 0
			
			.recognition-content.one-half
				width 100% !important
		
		.recognition-content.flex-row
			flex-direction column !important
				
		.recognition-icon
			margin 0
			
		.recognition-content-inner
			text-align center
			margin-bottom 20px
			width 100% !important
			padding 30px 0 !important
			
		
		.rewards-info-container
			margin-top 80px

			.stroke
				display none
</style>

